"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var semantic_ui_react_1 = require("semantic-ui-react");
var heroSection_1 = __importDefault(require("./sections/hero/heroSection"));
var index_1 = __importDefault(require("./sections/collections/index"));
var LoginModal_1 = __importDefault(require("../../login/LoginModal"));
var api = __importStar(require("../../api/backend.api"));
var loop_wallet_1 = require("../../Loop_Reuseable_Component/packages/loop_wallet");
var fans_module_scss_1 = __importDefault(require("./fans.module.scss"));
var datalayer_1 = require("../../components/datalayer");
var media_1 = __importDefault(require("./sections/fanClubMedia/media"));
var countdown_1 = __importDefault(require("./sections/countdown/countdown"));
var FaqLayout_1 = __importDefault(require("../../components/FaqLayout"));
var react_i18next_1 = require("react-i18next");
var common_1 = require("../../helpers/common");
function Fans() {
    var _this = this;
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
    var address = (0, loop_wallet_1.useWallet)().address;
    var pathname = window.location.pathname.split("/");
    var username = pathname[2];
    var _k = (0, react_1.useState)(), creatorData = _k[0], setCreatorData = _k[1];
    var _l = (0, react_1.useState)(false), creatorDataLoaded = _l[0], setCreatorDataLoaded = _l[1];
    var _m = (0, react_1.useState)(), collections = _m[0], setCollections = _m[1];
    var _o = (0, react_1.useState)(), exclusiveContent = _o[0], setExclusiveContent = _o[1];
    var _p = (0, react_1.useState)(false), openLoginModal = _p[0], setOpenLoginModal = _p[1];
    {
        /* Fetch Creator Profile */
    }
    (0, react_1.useEffect)(function () {
        var fetchCreatorData = function () { return __awaiter(_this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, api
                            .fansArtistData({ artist: username })
                            .then(function (res) {
                            setCreatorData(res);
                            setCreatorDataLoaded(true);
                        })
                            .then(function () { return __awaiter(_this, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                // Get Collections
                                api
                                    .fansCollections({ username: username })
                                    .then(function (res) { return setCollections(res); });
                                // Get Exclusive Content
                                api
                                    .fansExclusive({ artist: username })
                                    .then(function (res) { return setExclusiveContent(res); });
                                return [2 /*return*/];
                            });
                        }); })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); };
        if (!creatorDataLoaded) {
            fetchCreatorData();
        }
    }, [creatorDataLoaded]);
    {
        /* Data Layer */
    }
    (0, react_1.useEffect)(function () {
        var _a;
        if (creatorData && ((_a = creatorData === null || creatorData === void 0 ? void 0 : creatorData.user) === null || _a === void 0 ? void 0 : _a.username)) {
            (0, datalayer_1.datalayer)({
                event: "profile_view",
                event_action: "profile_view",
                event_label: creatorData.user.username,
            });
        }
    }, [creatorData]);
    var creator = creatorData === null || creatorData === void 0 ? void 0 : creatorData.user;
    //const creatorGallery = creator?.gallery?.gallery_items;
    var _collections = collections && collections[0];
    console.log(_collections);
    var faqs = (_b = (_a = _collections === null || _collections === void 0 ? void 0 : _collections.launchpad_type[0]) === null || _a === void 0 ? void 0 : _a.collection) === null || _b === void 0 ? void 0 : _b.faqs;
    var collectionUrl = _collections === null || _collections === void 0 ? void 0 : _collections.project_slug;
    return ((0, jsx_runtime_1.jsxs)("main", __assign({ className: "homepage HomePageFull" }, { children: [(0, jsx_runtime_1.jsx)("div", __assign({ className: "home" }, { children: creatorData && creatorDataLoaded ? ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(heroSection_1.default, { creator: creator, project_url: collectionUrl, collection_type: _collections === null || _collections === void 0 ? void 0 : _collections.collection_type, followers: creatorData === null || creatorData === void 0 ? void 0 : creatorData.followers, isAuthorized: address, handleLoginModal: function () { return setOpenLoginModal(true); } }), collections && ((0, jsx_runtime_1.jsx)(index_1.default, { collections: collections, creator: creator })), (0, jsx_runtime_1.jsx)(media_1.default, { data: creator }), ((_c = creator === null || creator === void 0 ? void 0 : creator.cta_banner) === null || _c === void 0 ? void 0 : _c.id) && ((0, jsx_runtime_1.jsx)("div", __assign({ className: "container hideMobile" }, { children: (0, jsx_runtime_1.jsx)("a", __assign({ href: creator === null || creator === void 0 ? void 0 : creator.cta_link, target: "_blank" }, { children: (0, jsx_runtime_1.jsx)("div", { className: fans_module_scss_1.default.cta_card, style: {
                                        backgroundImage: "url(".concat(process.env
                                            .REACT_APP_DIRECTUS_BACKEND_ASSETS +
                                            ((_d = creator === null || creator === void 0 ? void 0 : creator.cta_banner) === null || _d === void 0 ? void 0 : _d.id), ")"),
                                    } }) })) }))), (0, jsx_runtime_1.jsx)("div", __assign({ className: "container" }, { children: (0, jsx_runtime_1.jsxs)("div", __assign({ className: fans_module_scss_1.default.countdown }, { children: [(0, jsx_runtime_1.jsx)("h3", { children: (0, jsx_runtime_1.jsx)("span", { children: "Updates" }) }), (0, jsx_runtime_1.jsx)(countdown_1.default, { type: _collections === null || _collections === void 0 ? void 0 : _collections.collection_type, eventBg: (_e = creator === null || creator === void 0 ? void 0 : creator.event_background) === null || _e === void 0 ? void 0 : _e.id, eventDate: (_collections === null || _collections === void 0 ? void 0 : _collections.collection_type) == "event"
                                            ? creator === null || creator === void 0 ? void 0 : creator.event_date
                                            : ((_g = (_f = _collections === null || _collections === void 0 ? void 0 : _collections.launchpad_type[0]) === null || _f === void 0 ? void 0 : _f.launchInfo) === null || _g === void 0 ? void 0 : _g.startDate) +
                                                " " +
                                                ((_j = (_h = _collections === null || _collections === void 0 ? void 0 : _collections.launchpad_type[0]) === null || _h === void 0 ? void 0 : _h.launchInfo) === null || _j === void 0 ? void 0 : _j.startTime) }), (0, jsx_runtime_1.jsx)("a", __assign({ href: "".concat((0, common_1.ArenaLink)(collectionUrl)) }, { children: (0, jsx_runtime_1.jsx)(semantic_ui_react_1.Button, __assign({ className: "mainBtn ".concat(fans_module_scss_1.default.collection_btn) }, { children: (_collections === null || _collections === void 0 ? void 0 : _collections.collection_type) === "event" ? ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: (0, jsx_runtime_1.jsx)(react_i18next_1.Trans, { children: "getTicket" }) })) : (_collections === null || _collections === void 0 ? void 0 : _collections.collection_type) === "membership" ? ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: (0, jsx_runtime_1.jsx)(react_i18next_1.Trans, { children: "getMembership" }) })) : ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: (0, jsx_runtime_1.jsx)(react_i18next_1.Trans, { children: "exploreCollection" }) })) })) }))] })) })), faqs && (0, jsx_runtime_1.jsx)(FaqLayout_1.default, { faqs: faqs })] })) : !creatorData && !creatorDataLoaded ? ((0, jsx_runtime_1.jsx)("div", __assign({ className: "artistLoading" }, { children: (0, jsx_runtime_1.jsx)("div", { className: "mainLoader" }) }))) : ((0, jsx_runtime_1.jsx)("div", __assign({ className: "notFound" }, { children: (0, jsx_runtime_1.jsx)("p", { children: "Creator Not found" }) }))) })), (0, jsx_runtime_1.jsx)(LoginModal_1.default, { open: openLoginModal, close: function () { return setOpenLoginModal(false); }, showSignup: false, setShowSignUp: function () { } })] })));
}
exports.default = Fans;
